/* eslint-disable no-nested-ternary */
import React, { useState, useEffect, useCallback, useRef, useMemo } from 'react';
import './clientList.css';
import yn from 'yn';
import { Spin } from 'antd-v5';
import { LoadingOutlined } from '@ant-design/icons';
import ListOfClients from './ListOfClients';
import ClientHeader from './ClientHeader';
import { getRequest, postRequest } from '../../../../core/apiRequests';
import useSearchParams from '../../../../hooks/useSearchParams';
import { setTablePaginationRowCount, setTablePaginationPageCount } from '../../../../core/actions';
import { setSelectedClientList } from '../../../../reducers/client';
import { setLoadingStatus } from '../../../../reducers/notification';
import ClientsFilter, { filters } from '../../../Layout/ClientsFilter';
import useGetClients from '../../../../hooks/query/useGetClients';
import useDebounce from '../../../../hooks/useDebounce';
import { ExportClientsModal } from './ExportClientsModal';

const tableName = 'CLIENTS';

const ClientList = props => {
  const [search, setSearch] = useState('');
  const debounceSearch = useDebounce(search);
  const [loadingSearch, setLoadingSearch] = useState(false);
  const [checkedClient, setCheckedClient] = useState(false);
  const [asctFilterList, setAsctFilterList] = useState([]);
  const [tagFilterList, setTagFilterList] = useState([
    {
      label: (
        <span className="p-top-4 left" style={{ lineHeight: '30px' }}>
          All Tags
        </span>
      ),
      value: 0,
    },
  ]);
  const [allTags, setAllTags] = useState(false);
  const [page, setPage] = useState(1);
  const [isThereMoreClient, setIsThereMoreClient] = useState(true);
  const [hasFilter, setHasFilter] = useState(false);
  const [contactMethod, setContactMethod] = useState([
    { label: 'Email', value: 'EMAIL' },
    { label: 'SMS', value: 'SMS' },
  ]);
  const [exportClientListModal, setExportClientListModal] = useState(false);

  const { tableData, setTableData } = props;
  const isMounted = useRef(null);

  const { getAll } = useSearchParams();
  const params = getAll();

  const allFilters = useMemo(() => {
    let filter = {};
    if (params?.associates === 'none') {
      filter = { assignedAssociates: false };
    } else if (!params?.associates || params?.associates === 'all') {
      filter = {};
    } else {
      filter = { associateIds: params?.associates };
    }
    if (params?.tags === 'none') {
      filter = { ...filter, untagged: true };
    } else if (!params?.tags || params?.tags === 'all') {
      filter = { ...filter };
    } else {
      filter = { ...filter, tagIds: params?.tags };
    }

    if (params?.filterContactMethods && params?.filterContactMethods !== 'all') {
      if (params?.filterContactMethods === 'none') {
        filter = { ...filter, contactMethod: { exists: false } };
      } else {
        filter = { ...filter, contactMethod: { contactMethod: params?.filterContactMethods } };
      }
    }

    if (
      params?.filterCreatedDateRange?.length === 2 &&
      params?.filterCreatedDateRange[0] &&
      params?.filterCreatedDateRange[1]
    ) {
      filter = {
        ...filter,
        createdDate: {
          exists: true,
          dateRange: {
            startDate: params?.filterCreatedDateRange[0],
            endDate: params?.filterCreatedDateRange[1],
          },
        },
      };
    }

    if (params?.filterHasBirthday) {
      filter = {
        ...filter,
        birthday: { exists: true },
      };
    }
    if (params?.filterHasDoesNotHaveBirthday) {
      filter = {
        ...filter,
        birthday: { exists: false },
      };
    }
    if (
      params?.filterBirthdayDateRange?.length === 2 &&
      params?.filterBirthdayDateRange[0] &&
      params?.filterBirthdayDateRange[1]
    ) {
      filter = {
        ...filter,
        birthday: {
          dateRange: {
            startDate: params?.filterBirthdayDateRange[0],
            endDate: params?.filterBirthdayDateRange[1],
          },
        },
      };
    }
    if (params?.filterHasAnniversary) {
      filter = {
        ...filter,
        anniversary: { exists: true },
      };
    }
    if (params?.filterHasDoesNotHaveAnniversary) {
      filter = {
        ...filter,
        anniversary: { exists: false },
      };
    }
    if (
      params?.filterAnniversaryDateRange?.length === 2 &&
      params?.filterAnniversaryDateRange[0] &&
      params?.filterAnniversaryDateRange[1]
    ) {
      filter = {
        ...filter,
        anniversary: {
          dateRange: {
            startDate: params?.filterAnniversaryDateRange[0],
            endDate: params?.filterAnniversaryDateRange[1],
          },
        },
      };
    }

    if (params?.filterLastMessageNeverSent) {
      filter = {
        ...filter,
        lastMessageSent: { exists: false },
      };
    }
    if (
      params?.filterLastMessageSentDateRange?.length === 2 &&
      params?.filterLastMessageSentDateRange[0] &&
      params?.filterLastMessageSentDateRange[1]
    ) {
      filter = {
        ...filter,
        lastMessageSent: {
          dateRange: {
            startDate: params?.filterLastMessageSentDateRange[0],
            endDate: params?.filterLastMessageSentDateRange[1],
          },
        },
      };
    }

    if (params?.filterLastMessageNeverReceived) {
      filter = {
        ...filter,
        lastMessageReceived: { exists: false },
      };
    }
    if (
      params?.filterLastMessageReceivedDateRange?.length === 2 &&
      params?.filterLastMessageReceivedDateRange[0] &&
      params?.filterLastMessageReceivedDateRange[1]
    ) {
      filter = {
        ...filter,
        lastMessageReceived: {
          dateRange: {
            startDate: params?.filterLastMessageReceivedDateRange[0],
            endDate: params?.filterLastMessageReceivedDateRange[1],
          },
        },
      };
    }

    return {
      ...filter,
      storeId: !params?.stores || params?.stores === 'all' ? 0 : params?.stores[0],
    };
  }, [params]);

  const { data, isFetching } = useGetClients({
    data: {
      searchTerm: debounceSearch,
      offset: props.pagination.pageSize * (page - 1),
      limit: props.pagination.pageSize,
      archived: false,
      ...allFilters,
    },
    loadingStatusOff: true,
    useQueryOptions: {
      inititalData: {
        data: [],
        limit: props.pagination.pageSize,
        offset: 0,
        total: 0,
      },
      enabled: !!props.auth.merchantId,
      onSuccess: () => {
        setLoadingSearch(false);
      },
    },
  });

  useEffect(() => {
    let response = [];
    if (data?.data?.length > 0) {
      response = data.data.map(client => ({
        associate_ref: client?.associateIds,
        count: client?.tagIds === null || client?.tagIds === undefined ? 0 : client?.tagIds?.length,
        id: client?.id,
        name: client?.name,
        pos_ref_num: client?.referenceNumber,
        mobile: client?.mobile,
        email: client?.email,
        contactMethod: client?.contactMethod,
      }));
    } else {
      setTableData(prev => (page === 1 ? [] : prev));
    }
    if (page === 1) {
      setTableData(response);
    } else {
      setTableData(prev => [...prev, ...response]);
    }
    if (response.length === 25) {
      setIsThereMoreClient(true);
    } else {
      setIsThereMoreClient(false);
    }
    setTablePaginationRowCount(data.total, tableName);
    setTablePaginationPageCount(Math.ceil(data.total / props.pagination.pageSize), tableName);
  }, [data]);

  useEffect(() => {
    if (props?.auth?.enabled_whatsapp) {
      setContactMethod([
        { label: 'Email', value: 'EMAIL' },
        { label: 'SMS', value: 'SMS' },
        { label: 'WhatsApp', value: 'WHATSAPP' },
      ]);
    }
  }, [props.auth]);

  const exportClients = useCallback(
    async email => {
      const {
        pagination: { sortColumn, ascendingColumn },
      } = props;

      let selectedContactMethods = [];
      if (!params?.filterContactMethods || params?.filterContactMethods === 'all') {
        selectedContactMethods = 'all';
      } else {
        selectedContactMethods = params?.filterContactMethods;
      }

      let selectedStores = [];
      if (!params?.stores || params?.stores === 'all') {
        selectedStores = [0];
      } else if (params?.stores === 'none') {
        selectedStores = [];
      } else {
        selectedStores = params?.stores;
      }

      let selectedAssociates = [];
      if (!params?.associates || params?.associates === 'all') {
        selectedAssociates = [];
      } else if (params?.associates === 'none') {
        selectedAssociates = ['none'];
      } else {
        selectedAssociates = params?.associates;
      }

      let selectedTags = [];
      if (!params?.tags || params?.tags === 'all') {
        selectedTags = [];
      } else if (params?.tags === 'none') {
        selectedTags = 'none';
      } else {
        selectedTags = params?.tags.map(item => +item);
      }
      if (selectedStores.length > 0) {
        await new Promise(resolve => {
          setTimeout(resolve, 300);
        });

        const reqObj = {
          params: ['clients', 'export'],
          data: {
            format: 'csv',
            email: email || null,
          },
          query: {
            selectedStores: JSON.stringify(selectedStores),
            filterTags: JSON.stringify(selectedTags),
            myClients: props.filters.myClients,
            filterAssociates: JSON.stringify(selectedAssociates),
            sort_order: sortColumn,
            sort_direction: ascendingColumn,
            search: debounceSearch,
          },
          loadingStatusOff: true,
        };
        // eslint-disable-next-line no-unused-expressions
        Object.assign(reqObj.query, {
          filterBirthdayDateRange: params?.filterBirthdayDateRange
            ? JSON.stringify([
              params?.filterBirthdayDateRange[0] ? params?.filterBirthdayDateRange[0] : null,
              params?.filterBirthdayDateRange[1] ? params?.filterBirthdayDateRange[1] : null,
            ])
            : JSON.stringify([null, null]),
          filterHasBirthday: !!params?.filterHasBirthday,
          filterHasDoesNotHaveBirthday: !!params?.filterHasDoesNotHaveBirthday,
          filterAnniversaryDateRange: params?.filterAnniversaryDateRange
            ? JSON.stringify([
              params?.filterAnniversaryDateRange[0] ? params?.filterAnniversaryDateRange[0] : null,
              params?.filterAnniversaryDateRange[1] ? params?.filterAnniversaryDateRange[1] : null,
            ])
            : JSON.stringify([null, null]),
          filterHasAnniversary: !!params?.filterHasAnniversary,
          filterHasDoesNotHaveAnniversary: !!params?.filterHasDoesNotHaveAnniversary,
          filterCreatedDateRange: params?.filterCreatedDateRange
            ? JSON.stringify([
              params?.filterCreatedDateRange[0] ? params?.filterCreatedDateRange[0] : null,
              params?.filterCreatedDateRange[1] ? params?.filterCreatedDateRange[1] : null,
            ])
            : JSON.stringify([null, null]),
          filterContactMethods: JSON.stringify(selectedContactMethods),
          filterLastMessageSentDateRange: params?.filterLastMessageSentDateRange
            ? JSON.stringify([
              params?.filterLastMessageSentDateRange[0] ? params?.filterLastMessageSentDateRange[0] : null,
              params?.filterLastMessageSentDateRange[1] ? params?.filterLastMessageSentDateRange[1] : null,
            ])
            : JSON.stringify([null, null]),
          filterLastMessageReceivedDateRange: params?.filterLastMessageReceivedDateRange
            ? JSON.stringify([
              params?.filterLastMessageReceivedDateRange[0] ? params?.filterLastMessageReceivedDateRange[0] : null,
              params?.filterLastMessageReceivedDateRange[1] ? params?.filterLastMessageReceivedDateRange[1] : null,
            ])
            : JSON.stringify([null, null]),
          filterLastMessageNeverSent: !!params?.filterLastMessageNeverSent,
          filterLastMessageNeverReceived: !!params?.filterLastMessageNeverReceived,
        });

        await postRequest(reqObj);
      }
    },
    [getRequest, params, props],
  );

  const watchFilters = useMemo(() => {
    return filters.reduce((acc, param) => {
      const paramValue = new URLSearchParams(window.location.search).get(param) || '';
      return { ...acc, [param]: paramValue };
    }, {});
  }, [window.location.search]);
  useEffect(() => {
    setPage(1);
    document.getElementById('scrollableDivChat')?.scrollTo(0, 0);
    setSelectedClientList([]);
    setAllTags(false);
  }, [
    watchFilters.filterBirthdayDateRange,
    watchFilters.filterHasBirthday,
    watchFilters.filterHasDoesNotHaveBirthday,
    watchFilters.filterHasDoesNotHaveAnniversary,
    watchFilters.filterHasAnniversary,
    watchFilters.filterAnniversaryDateRange,
    watchFilters.filterLastMessageNeverSent,
    watchFilters.filterLastMessageSentDateRange,
    watchFilters.filterLastMessageNeverReceived,
    watchFilters.filterLastMessageReceivedDateRange,
    watchFilters.filterCreatedDateRange,
    watchFilters.filterContactMethods,
    watchFilters.stores,
    watchFilters.associates,
    watchFilters.tags,
  ]);

  const getTagsAndAssociates = async () => {
    const {
      auth: { userId, role },
    } = props;
    if (props.auth.merchantId) {
      const storeIds = [];
      props.auth.stores.forEach(store => {
        if (store.id !== 0) {
          storeIds.push(store.id);
        }
      });
      const reqObj = {
        params: ['clients', props.auth.merchantId, 'tagsAndAssociates'],
        query: {
          userId,
          role,
          storeIds: [...storeIds],
        },
        loadingStatusOff: true,
      };

      await new Promise(resolve => {
        setTimeout(resolve, 500);
      });

      setLoadingStatus(true);

      const responseData = await getRequest(reqObj);

      if (responseData && responseData.length > 0) {
        const dataObj = responseData[0];
        const { tags, associates } = dataObj;
        const sortedTags = tags.sort((a, b) => {
          if (a.name.toLowerCase() > b.name.toLowerCase()) {
            return 1;
          }
          if (b.name.toLowerCase() > a.name.toLowerCase()) {
            return -1;
          }
          return 0;
        });
        const dropDownTags = sortedTags.map(tag => ({
          label: tag.name,
          tagColor: tag.color,
          value: tag.id,
        }));
        const dropDownAscts = associates.map(asct => ({
          label: `${asct.first_name || ''} ${asct.last_name || ''}`,
          value: asct.id,
        }));
        setTagFilterList([...dropDownTags]);
        setAsctFilterList([...dropDownAscts]);
      }

      setLoadingStatus(false);
    }
  };

  useEffect(() => {
    isMounted.current = true;
    const {
      auth: { merchantId },
    } = props;
    if (merchantId) {
      getTagsAndAssociates();
    }
    return () => {
      isMounted.current = false;
    };
  }, [
    props.auth.stores,
    props.filters.clientFilterTags,
    props.filters.clientFilterAssociates,
    props.filters.myClients,
    props.auth.storeId,
    page,
  ]);

  useEffect(() => {
    if (debounceSearch !== '') {
      setPage(1);
      setSelectedClientList([]);
      setAllTags(false);
      setLoadingSearch(true);
      document.getElementById('scrollableDivChat')?.scrollTo(0, 0);
    } else {
      setPage(1);
      setSelectedClientList([]);
      setAllTags(false);
      setLoadingSearch(true);
      document.getElementById('scrollableDivChat')?.scrollTo(0, 0);
    }
  }, [debounceSearch]);

  const listAdder = id => {
    const tempArr = props.client.selected_client_list;
    const clicked = tempArr.includes(id);

    if (clicked) {
      const spliceArray = tempArr.indexOf(id);
      if (spliceArray !== -1) {
        tempArr.splice(spliceArray, 1);
        setSelectedClientList(tempArr);
      }
      setAllTags(false);
    } else if (!clicked) {
      tempArr.push(id);
      setSelectedClientList(tempArr);
    }
  };
  return (
    <div className="" style={{ borderRight: '1px solid #EBEBEB' }}>
      {/* client filter */}
      <ClientsFilter
        layoutClass="clientFilter"
        authenticated={props.auth?.authenticated || false}
        merchantId={props.auth?.merchantId}
        userId={props.auth?.userId}
        role={props.auth?.role}
        open={props.clientFilterOpen}
        contactMethodOptions={contactMethod}
        associates={asctFilterList}
        tags={tagFilterList}
        setOpen={value => props.setClientFilterOpen(value)}
        setHasFilter={value => setHasFilter(value)}
      />
      {/* client list portion */}
      <div className="m-top-15">
        <ClientHeader
          setSearch={setSearch}
          search={search}
          setClientFilterOpen={props.setClientFilterOpen}
          clientFilterOpen={props.clientFilterOpen}
          getCSVData={() => setExportClientListModal(true)}
          auth={props.auth}
          client={props.client}
          stores={props.auth.stores}
          getClientData={props.getClientData}
          hasFilter={hasFilter}
          loadingSearch={loadingSearch}
        />
        <Spin tip="Loading..." size="large" indicator={<LoadingOutlined spin />} spinning={isFetching}>
          <ListOfClients
            getClientData={props.getClientData}
            setAllTags={setAllTags}
            pagination={props.pagination}
            allTags={allTags}
            tableData={tableData}
            setTableData={setTableData}
            search={search}
            listAdder={listAdder}
            setCheckedClient={setCheckedClient}
            checkedClient={checkedClient}
            setSelectedClientList={setSelectedClientList}
            selected_client_list={props.client.selected_client_list}
            client={props.client}
            auth={props.auth}
            setPage={setPage}
            page={page}
            isThereMoreClient={isThereMoreClient}
            isFetching={isFetching}
          />
        </Spin>
      </div>
      <ExportClientsModal
        open={exportClientListModal}
        onClose={() => setExportClientListModal(false)}
        onSubmit={email => exportClients(email)}
        userEmail={props.auth.email}
      />
    </div>
  );
};

export default ClientList;
